import React, { useState, useRef } from 'react';
import {
  Button,
  CircularProgress,
  ClickAwayListener,
  TextareaAutosize,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import clsx from 'clsx';

import useProfileOwner from 'hooks/useProfileOwner';
import { putRequest } from 'utils/api';
import { updateProfile } from 'features/authSlice';
import { useSelector } from 'react-redux';
import ProfileOnboardingSteps from './profile/ProfileOnboardingSteps';
import styles from 'styles/components/profile/Profile.module.scss';

const buttonStyle = { height: 40, marginTop: 10, width: 100 };
const size = { width: 30, height: 30 };

const Bio = ({ profile, setProfile, profilePreview }) => {
  const [bio, setBio] = useState(profile.bio);
  const [edit, setEdit] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const isLoggedIn = useSelector(state => state.auth.loggedIn);
  const profileOwner = useProfileOwner(profile);
  const dispatch = useDispatch();
  const inputRef = useRef();
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleSave = () => {
    setIsLoading(true);

    putRequest({
      endpoint: `profiles/${profile.id}`,
      data: { bio },
    })
      .then(response => {
        dispatch(updateProfile(response.data));
        setProfile && setProfile(response.data);
        setEdit(false);
        setIsLoading(false);
      })
      .catch(() => setIsLoading(false));
  };

  return (
    <div>
      {profilePreview ? (
        <p className={styles.previewBio}>{profile.bio}</p>
      ) : (
        <div
          className={clsx(styles.influencerBio, { [styles.hover]: profileOwner })}
          style={!profileOwner && mobile ? { background: '#fff' } : {}}
        >
          {!profilePreview && profileOwner && <ProfileOnboardingSteps />}

          <div
            onClick={() => {
              if (isLoggedIn && profileOwner) {
                setEdit(true);

                setTimeout(() => {
                  inputRef.current.selectionStart = bio.length;
                  inputRef.current.selectionEnd = bio.length;
                });
              }
            }}
          >
            {edit ? (
              <ClickAwayListener onClickAway={() => setEdit(false)}>
                <div className={styles.bioBorder}>
                  <div className={styles.textarea}>
                    <TextareaAutosize
                      onChange={e => setBio(e.target.value)}
                      defaultValue={profile.bio}
                      maxLength={150}
                      autoFocus={edit}
                      ref={inputRef}
                    />

                    <Button
                      onClick={handleSave}
                      variant="contained"
                      color="primary"
                      disabled={isLoading}
                      style={buttonStyle}
                    >
                      {isLoading ? <CircularProgress style={size} /> : 'Save'}
                    </Button>
                  </div>
                </div>
              </ClickAwayListener>
            ) : (
              <div className={styles.bioBorder} style={!profileOwner ? { border: 'none' } : {}}>
                {profile.bio}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

Bio.propTypes = {
  profile: PropTypes.object.isRequired,
  setProfile: PropTypes.func,
  profilePreview: PropTypes.bool,
};

Bio.defaultProps = {
  setProfile: () => {},
  profilePreview: false,
};

export default Bio;
